module.exports = __webpack_public_path__ + "static/media/5.c3b7e56e.jpg";